<template>
  <v-form ref="formulario">
    <div style="min-height:350px;">

      <v-layout wrap>

        <v-flex xs12>
          <provider-title title="Agenda"></provider-title>

          <provider-sub-title class="mt-4" text="Agenda pública"/>
          <v-switch
                  color="primary"
                  :label="`Permite a tus ${clientPlural.toLowerCase()} agendar sus propias citas`"
                  v-model="settings.allow_public_scheduling"
                  hide-details
          ></v-switch>
        </v-flex>

        <v-flex xs12 mt-3>
          <v-divider></v-divider>
        </v-flex>

        <v-flex xs12 md6>
          <provider-sub-title class="mt-2" text="Mensaje Personalizado"/>
        </v-flex>

        <v-flex xs12 >
          <v-switch
              class="mb-2"
              label="Mostrar mensaje"
              :hint="`muestra un mensaje personalizado a los ${clientPlural.toLowerCase()} despues de agendar`"
              persistent-hint
              v-model="settings.allow_public_schedule_post_message"
          ></v-switch>
          <v-slide-y-transition>
            <wysiwyg v-show="settings.allow_public_schedule_post_message" v-model="settings.public_schedule_post_message"></wysiwyg>
          </v-slide-y-transition>
        </v-flex>

        <v-flex xs12 mt-3>
          <v-divider></v-divider>
        </v-flex>

        <v-flex xs12>

          <provider-sub-title class="mt-2" :text="clientFieldsTitle" />
          <small class="small">Selecciona los datos que necesites recolectar en las citas</small>

          <v-slide-y-transition>
            <v-layout wrap v-show="!loadingClientFields">
              <v-flex xs12 >
                <v-data-table

                  :headers="headers"
                  :items="fieldItems"
                  :server-items-length="100"
                  hide-default-footer
                  :loading="loadingClientFields"
                >
                  <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                  <template v-slot:item="props" >
                    <tr>
                      <td>{{ props.item.label }}</td>

                      <td class="text-center" v-if="!!syncedClientFields[props.item.id]">
                        <v-switch
                            color="primary"
                            v-model="syncedClientFields[props.item.id].checked"
                            hide-details
                        />
                      </td>
                      <td class="text-center" v-if="!!syncedClientFields[props.item.id]">
                        <v-switch
                            :disabled="!syncedClientFields[props.item.id].checked"
                            color="primary"
                            v-model="syncedClientFields[props.item.id].required"
                            hide-details
                        />
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-slide-y-transition>


        </v-flex>

      </v-layout>

    </div>

    <div class="text-right mt-2">
      <v-btn color="primary" @click="save" :loading="loadingSave">Guardar</v-btn>
    </div>

  </v-form>
</template>

<script>

  import {mapState, mapMutations, mapActions} from 'vuex'
  import {ApiUtils} from '@/utils/ApiUtils'
  import {getLabel} from '@/utils/Institution'

export default {
  components: {
    ProviderTitle: () => import('@/components/providers/panel/ProviderTitle'),
    ProviderSubTitle: () => import('@/components/providers/panel/ProviderSubTitle')
  },
  props: {},
  data() {
    return {
      headers: [
        {
          text: 'Campo',
          align: 'left',
          value: 'label',
          sortable: false,
        },
        { text: 'Solicitar', sortable: false, align: 'left' },
        { text: 'Obligatorio', sortable: false, align: 'left' }
      ],
      settings: {
        quotation_expiration_days: 10,
        allow_quotation: true,
        allow_public_quotation: false,
        allow_scheduling: true,
        allow_public_scheduling: false,
        allow_public_schedule_post_message: false,
        public_schedule_post_message: '',
      },
      syncedClientFields: {},
      loading: true,
      loadingSavePublicAppointment: false,
      loadingSavePostMessageSettings: false,
      loadingSyncFields: false,
      loadingSyncedFields: false,
      emailPersonal: false,
      emailRules: [
        v => {
          if (!this.emailPersonal) {
            return /.+@.+/.test(v) || 'E-mail inválido'
          } else {
            return true
          }
        }
      ]
    }
  },
  watch: {
    currentProvider(){
      const vm = this
      vm.loadData()
    },
    availableFields(val){
      var vm = this
      if(val){
        vm.setAvailableClientFields()
      }
    },
    noQuotations: function(val) {
      if (val) {
        this.settings.quotation_expiration_days = 0
      }
    },
    emailPersonal: function(val) {
      if (val) {
        this.settings.notification_email = this.currentUser.email
      } else {
        this.settings.notification_email = ''
      }
    }
  },
  async mounted() {
    var vm = this
    const current = vm.currentProvider.settings
    vm.settings = {
      quotation_expiration_days: current.quotation_expiration_days,
      allow_quotation: current.allow_quotation,
      allow_public_quotation: current.allow_public_quotation,
      allow_scheduling: current.allow_scheduling,
      allow_public_scheduling: current.allow_public_scheduling,
      allow_public_schedule_post_message: current.allow_public_schedule_post_message,
      public_schedule_post_message: current.public_schedule_post_message
    }

    vm.loadData()

  },
  computed: {
    ...mapState(['currentUser', 'currentProvider']),
    ...mapState('preloads', {
      availableFields: state => state.availableClientFormFields,
      loadingAvailableFields: state => state.loadingAvailableClientFormFields
    }),
    fieldItems(){
      var vm = this
      const fields = []
      for(let i in vm.availableFields){
        let currentField = vm.availableFields[i]
        fields.push(currentField)
      }

      return fields

    },
    clientFieldsTitle(){
      return `Datos del ${getLabel('commons.client.singular').toLowerCase()}`
    },
    clientFieldsSubTitle(){
      return `¿Qué datos necesitas recolectar para tus citas?`
    },
    loadingSave(){
      return this.loadingSyncFields || this.loadingSavePublicAppointment || this.loadingSavePostMessageSettings
    },
    loadingClientFields(){
      return this.loadingAvailableFields || this.loadingSyncedFields || this.loading
    },
    noQuotations(){

        if (!this.settings.allow_quotation && !this.settings.allow_public_quotation) {
          return true
        }

        return false

    }
  },
  methods: {
    ...mapActions('preloads', ['loadAvailableClientFormFields']),
    async loadData(){
      const vm = this
      if(vm.availableFields.length === 0){
        await vm.loadAvailableClientFormFields()
      }

      vm.setAvailableClientFields()
      vm.$nextTick(function(){
        vm.getSyncedClientFormFields()
      })
    },
    setAvailableClientFields(){
      var vm = this

      for(let i in vm.availableFields){
        let currentField = vm.availableFields[i]
        if(vm.syncedClientFields[currentField.id]){
          vm.syncedClientFields[currentField.id].checked = false
          vm.syncedClientFields[currentField.id].required = false
          vm.syncedClientFields[currentField.id].label = currentField.label
        }else{
          vm.syncedClientFields[currentField.id] = {
            checked: false,
            required: false,
            label: currentField.label
          }
        }
      }

    },
    save(){
      this.savePublicAppointment()
      this.saveClientFormFields()
      this.savePostMessageSettings()
    },
    async savePublicAppointment() {

      var vm = this
      if (vm.loadingSavePublicAppointment) return

      const { id } = vm.currentProvider

      vm.loadingSavePublicAppointment = true
      const response = await ApiUtils.makePatch(`provider/${vm.currentProvider.id}/settings`, null, {
        allow_scheduling: 1,
        allow_public_scheduling: vm.settings.allow_public_scheduling ? 1 : 0
      })

      if (response.ok) await ApiUtils.fetchMe()
      vm.loadingSavePublicAppointment = false

    },
    async savePostMessageSettings(){
      var vm = this
      if (vm.loadingSavePostMessageSettings) return

      const { id } = vm.currentProvider

      vm.loadingSavePostMessageSettings = true
      const response = await ApiUtils.makePatch(`provider/${id}/settings/post-schedule`, null, {
        public_schedule_post_message: vm.settings.public_schedule_post_message,
        allow_public_schedule_post_message: vm.settings.allow_public_schedule_post_message ? 1 : 0
      })

      if (response.ok) await ApiUtils.fetchMe()
      vm.loadingSavePostMessageSettings = false
    },
    async saveClientFormFields(){

      var vm = this
      if(vm.loadingSyncFields || !vm.currentProvider) return

      var fields = []
      for(var i in vm.syncedClientFields){
        let currentField = vm.syncedClientFields[i]
        if(currentField.checked){
          fields.push({
            id: i,
            required: currentField.required ? 1 : 0
          })
        }
      }


      vm.loadingSyncFields = true
      const response = await ApiUtils.makePatch(`provider/${vm.currentProvider.id}/settings/client-fields`, null, {fields: fields})
      vm.loadingSyncFields = false

      if(!response.ok){
        vm.$store.commit('showSnackBar', {
          text: 'Ha ocurrido un error intentando guardar los datos del cliente',
          color: 'error'
        })
      }else{
        vm.$store.commit('showSnackBar', {
          text: 'Configuración actualizada correctamente',
          color: 'success'
        })
      }

    },
    async getSyncedClientFormFields(){

      var vm = this
      if(!vm.currentProvider) return

        const fields = vm.currentProvider.settings.client_form_fields
        var currentFields = JSON.parse(JSON.stringify(vm.syncedClientFields))

        for(let i in fields){
          let currentField = fields[i]
          if(currentFields[currentField.id]){
            currentFields[currentField.id].checked = true
            currentFields[currentField.id].required = currentField.pivot.required ? true : false
          }
        }

        vm.syncedClientFields = currentFields
        vm.loading = false

    }
  }
}
</script>
<style scoped>

>>>.fr-second-toolbar{
  display: none !important;
}

  >>>.v-datatable__actions{
    display: none;
  }

.ancho {
  max-width: 300px;
}
</style>
